import {ref, reactive, computed, watch, watchEffect, nextTick} from 'vue';
import config from "@/config/config.json";
import {useTool} from "@/modules/reader/tools/tools"
import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";

/**
 * all state changes when interacting with the book are regarded as recorded here
 */
const bookInfoState = reactive({
    publicPath:null,
    ebookDownloadPath:null,
    ebookmodulename:null,//hkep version uses this
    ebookname:null, //jp version uses this
    availableSpeech:[],
    activeSpeech: config.reader.defaultSpeech,
    globalHanVisible:true,
    globalPinYinVisible:true,
    localHanVisible:[],
    localPinYinVisible:[],
    toggleHintsStatus:[],
    activeVideoData:null,
    activeGlossaryData:null,
    activeAudioSrc:null,
    popupHtmlData:null,
    popupImageData:null,
    stepByStepProgress:[],
    audioPlaybackRate:1,
    hintOrderSolid:[],
    hintOrderTransparent:[],
    isShowRateControl:false,
    isShowSyncOptions:false, // tell whether showing the backup/restore icons on header or not
    gradecode:null,
    subjectcode:null,
    flipClassroom:false
})

const {closeToolBoxAndPanel} = useTool();

export function useBookInfo() {


    /**
     * get info form config.json
     */
    const setDataFromConfig = (config) => {

        if (!config) {
            return;
        }

        if (config.config.language) {
            bookInfoState.availableSpeech = config.config.language.split(",")
            if (bookInfoState.availableSpeech.length === 1) {
                bookInfoState.activeSpeech = bookInfoState.availableSpeech[0];
                console.log("  bookInfoState.activeSpeech : " +   bookInfoState.activeSpeech )
            }
        }

        if (config.config.flip_classroom_video && config.config.flip_classroom_video === 1) {
            bookInfoState.flipClassroom = true;
        }

        if (config.config.hanzi && config.config.hanzi === 1) {
            bookInfoState.hanzi = true;
        }

        if (config.config.pinyin && config.config.pinyin === 1) {
            bookInfoState.pinyin = true;
        }
    }

    const toggleSpeech = ()=> {
        bookInfoState.activeSpeech = (bookInfoState.activeSpeech === "YY") ? "PN" : "YY";
    }

    const toggleGlobalHan = ()=>{
        bookInfoState.globalHanVisible = ! bookInfoState.globalHanVisible;


        for (let item of bookInfoState.localHanVisible) {
            for (let key in item) {
                item[key] = bookInfoState.globalHanVisible;
            }
        }

    }

    const toggleGlobalPinYin = ()=>{
        bookInfoState.globalPinYinVisible = !bookInfoState.globalPinYinVisible;

        for (let item of bookInfoState.localPinYinVisible) {
            for (let key in item) {
                item[key] = bookInfoState.globalPinYinVisible;
            }
        }
    }

    const setPopupHtmlData = (url, size)=> {
        bookInfoState.popupHtmlData = {
            url:url,
            size:size
        }
    }

    const removePopupHtmlData = ()=>{
        bookInfoState.popupHtmlData = null;
    }

    const setPopupImgaeData = (url, size)=> {
        bookInfoState.popupImageData = {
            url:url,
            size:size
        }
    }

    const removePopupImgaeData = ()=>{
        bookInfoState.popupImageData = null;
    }

    const setActiveVideoData =  (data)=> {
        bookInfoState.activeVideoData = data;
    }

    const removeActiveVideoData =  ()=> {
        bookInfoState.activeVideoData = null;
    }

    const setActiveAudioSrc = (src)=> {

        removeActiveAudioSrc();

        nextTick(()=> {
            if (document.getElementById("simpleAudioPlayer")) {
                document.getElementById("simpleAudioPlayer").currentTime = 0;
            }

            bookInfoState.activeAudioSrc = src;
        });
    }

    const removeActiveAudioSrc =  ()=> {
        bookInfoState.activeAudioSrc = null;

    }

    const removeGlossary = ()=> {
        bookInfoState.activeGlossaryData = null;
    }

    /**
     * Remove all sound and video and other resources like glossary
     */
    const removeAllMedia = ()=> {
        removeActiveVideoData();
        removeActiveAudioSrc();
        useKaraokeControl().reset();
        usePlayBlockControl().reset();
        removeGlossary();
        removePopupHtmlData();
    }

    const toggleSyncOptions = (e)=> {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        bookInfoState.isShowSyncOptions = !bookInfoState.isShowSyncOptions
        closeToolBoxAndPanel();
    }

    const closeSyncOptions = ()=> {
        bookInfoState.isShowSyncOptions = false;

    }

    const reset = ()=> {
        console.log("reset @bookInfo.js")
        bookInfoState.publicPath=null;
        bookInfoState.ebookDownloadPath=null;
        bookInfoState.ebookmodulename = null;
        bookInfoState.ebookname = null;
        bookInfoState.availableSpeech=[];
        bookInfoState.activeSpeech=config.reader.defaultSpeech;
        bookInfoState.globalHanVisible=true;
        bookInfoState.globalPinYinVisible=true;
        bookInfoState.localHanVisible=[];
        bookInfoState.localPinYinVisible=[];
        bookInfoState.toggleHintsStatus=[];
        bookInfoState.activeVideoData=null;
        bookInfoState.activeGlossaryData = null;
        bookInfoState.activeAudioSrc=null;
        bookInfoState.popupHtmlData=null;
        bookInfoState.popupImageData=null;
        bookInfoState.stepByStepProgress = [];
        bookInfoState.audioPlaybackRate = 1;
        bookInfoState.hintOrderSolid = [];
        bookInfoState.hintOrderTransparent = [];
        bookInfoState.isShowRateControl = false;
        bookInfoState.isShowSyncOptions = false;
        bookInfoState.gradecode = null;
        bookInfoState.subjectcode = null;
        bookInfoState.flipClassroom = null;
        bookInfoState.hanzi = null;
        bookInfoState.pinyin = null;
    }

    return {
        bookInfoState,
        removePopupHtmlData,
        removePopupImgaeData,
        setPopupHtmlData,
        setPopupImgaeData,
        setActiveVideoData,
        removeActiveVideoData,
        removeGlossary,
        setActiveAudioSrc,
        removeActiveAudioSrc,
        toggleSpeech,
        setDataFromConfig,
        toggleGlobalHan,
        toggleGlobalPinYin,
        removeAllMedia,
        toggleSyncOptions,
        closeSyncOptions,
        reset
    }
}
